import {
    initializeThemeStore,
    initializeThemeStoreForOpx,
    type ThemeId,
    ThemeMode,
} from 'mini-theme';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNonPrivateCloud } from 'mini-common-utils/lib/utils/isNonPrivateCloud';

/**
 * Load the initial theme based on the user config
 * For an OPX flow, get the palette from the host and initialize the theme
 * @param sessionDataPromise
 */
export const initializeTheme = async (): Promise<void> => {
    const isPrivateCloud = !isNonPrivateCloud();
    if (isPrivateCloud) {
        initializeThemeStore('Blue', ThemeMode.Light);
    } else if (isMiniHostAppFeatureEnabled('loadThemeFromHostApp')) {
        initializeThemeStoreForOpx();
    } else {
        initializeThemeStore();
    }
};
